import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { DataService } from "../../core/data.service";
import { TenantIdentifier } from "../models/tenant-identifier";
import { ODataResponse } from '../models/odata-response';
import { AppConfigService } from 'src/app/core/app-config.service';

@Injectable({
  providedIn: "root",
})
export class TenantIdentifierDataService extends DataService<TenantIdentifier> {
  constructor(http: HttpClient, acs: AppConfigService) {
    super(http, "TenantIdentifiers", acs);
  }

  identifierCount(
    tenantIdentifierId: number,
    value: string
  ) {
    let url = `${this.acs.current.configApiUrl}odata/TenantIdentifiers?$filter=Value eq '${value}' and Id ne ${tenantIdentifierId}&$count=true&$top=0`;
    return this.http.get<ODataResponse<TenantIdentifier>>(url);
  }   
}
